import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { logout } from "../ReduxToolkit/Reducers/AdminAuthSlice";

const CrmSecureRoute = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated } = useSelector((state: any) => state.adminAuth);
    const [isChecking, setIsChecking] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('crmtoken');
            if (!token) {
                dispatch(logout());
            }
            setIsChecking(false);
        };

        checkAuth();

        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'crmtoken') {
                checkAuth();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [dispatch]);

    useEffect(() => {
        if (!isChecking && !isAuthenticated) {
            dispatch(logout());
        }
    }, [isAuthenticated, isChecking, dispatch]);

    if (isChecking) {
        return null;
    }

    return isAuthenticated ? <>{children}</> : <Navigate to="/CRMLogin" />;
};

export default CrmSecureRoute;
